import * as all_hits_components from "components/page-components/Internal-Search/hit-components"

import React from "react"

export const getHitComponent = ({ type, ...rest }) => {
  const hit_type_mapping = {
    notice: { name: "Ausschreibungen", component_name: "NoticesHits" },
    event: { name: "Veranstaltungen", component_name: "EventHits" },
    lexicon: { name: "Lexikon", component_name: "LexiconpostsHits" },
    blog: { name: "Blog", component_name: "BlogpostsHits" },
    news: { name: "News", component_name: "NewsHits" },
    job_posting: { name: "Jobs", component_name: "JobHits" },
    page: { name: "Seiten", component_name: "PagesHits" },
    author: { name: "Autoren", component_name: "AuthorsHits" },
    "help-article": { name: "Hilfe-Themen", component_name: "HelpcenterHits" },
  }

  const Component = all_hits_components[hit_type_mapping[type].component_name]
  return {
    name: hit_type_mapping[type].name,
    HitsComponent: ({ ...rest }) => <Component {...rest} />,
  }
}
